import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, Flex, Text } from '@chakra-ui/react';
import CloverSidebarSimple from './CloverSidebarSimple';
import Dashboard from '../../pages/clover/Dashboard';
import Contacts from '../../pages/clover/Contacts';
import Invoices from '../../pages/clover/Invoices';
import Revenue from '../../pages/clover/Revenue';
import Templates from '../../pages/clover/Templates';
import Health from '../../pages/clover/Health';

const SimpleHeader: React.FC = () => (
  <Box bg="gray.800" borderBottom="1px" borderColor="gray.700" px={6} py={4}>
    <Text fontSize="2xl" fontWeight="semibold" color="white">
      Clover Portal
    </Text>
    <Text fontSize="sm" color="gray.300" mt={1}>
      Customer service portal for Clover Ridge Technologies
    </Text>
  </Box>
);

const CloverAppWorking: React.FC = () => {
  return (
    <Flex h="100vh" bg="gray.900">
      {/* Sidebar */}
      <CloverSidebarSimple />
      
      {/* Main Content Area */}
      <Flex direction="column" flex={1} overflow="hidden">
        {/* Header */}
        <SimpleHeader />
        
        {/* Content */}
        <Box flex={1} overflow="auto" p={6} bg="gray.900">
          <Routes>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="invoices/*" element={<Invoices />} />
            <Route path="revenue" element={<Revenue />} />
            <Route path="templates" element={<Templates />} />
            <Route path="health" element={<Health />} />
            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="dashboard" replace />} />
          </Routes>
        </Box>
      </Flex>
    </Flex>
  );
};

export default CloverAppWorking;